import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook for saving investor context data
 */
export const useContextData = () => {
  /**
   * Save investor context data to database only
   */
  const saveContextData = useCallback(async (relevanceContext: string, businessInfo: string): Promise<boolean> => {
    try {
      // Get current user
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user?.id) {
        console.log("Cannot save context data - user not authenticated");
        return false;
      }
      
      // Check if the record exists
      const { data: existingData, error: checkError } = await supabase
        .from('ai_context')
        .select('id')
        .eq('user_id', session.user.id)
        .maybeSingle();
      
      if (checkError) {
        console.error("Error checking for existing context:", checkError);
      }
      
      // If record exists, update it
      if (existingData?.id) {
        const { error } = await supabase
          .from('ai_context')
          .update({
            relevance_context: relevanceContext,
            business_info: businessInfo,
            updated_at: new Date().toISOString()
          })
          .eq('id', existingData.id);
        
        if (error) {
          console.error("Error updating context data:", error);
          return false;
        }
      } else {
        // Otherwise insert a new record
        const { error } = await supabase
          .from('ai_context')
          .insert({
            user_id: session.user.id,
            relevance_context: relevanceContext,
            business_info: businessInfo
          });
        
        if (error) {
          console.error("Error inserting context data:", error);
          return false;
        }
      }
      
      return true;
    } catch (error) {
      console.error("Error in saveContextData:", error);
      return false;
    }
  }, []);
  
  return {
    saveContextData
  };
};
